(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vertrag-widerrufen"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-widerruf]');
    if (!root) return;
    var form = root.querySelector('[data-widerruf-form]');
    var formWrap = root.querySelector('[data-widerruf-form-wrap]');
    var success = root.querySelector('[data-widerruf-success]');
    var errorBox = root.querySelector('[data-widerruf-error]');
    var submit = root.querySelector('[data-widerruf-submit]');
    var itemsField = root.querySelector('[data-widerruf-items]');
    var endpoint = root.getAttribute('data-endpoint');
    var FALLBACK = 'Bitte versuche es erneut oder sende deinen Widerruf per E-Mail an info@medsox.de.';

    // Bestellnummer aus Mail-Links vorbelegen (?bestellung=1234) — keine weiteren Daten in der URL
    try {
      var pre = new URLSearchParams(window.location.search).get('bestellung');
      if (pre) form.elements.order_ref.value = pre.slice(0, 120);
    } catch (e) {}

    function syncScope() {
      var partial = form.elements.scope.value === 'partial';
      itemsField.hidden = !partial;
      form.elements.items_note.required = partial;
    }
    form.addEventListener('change', syncScope);
    syncScope();

    function showError(msg) {
      errorBox.textContent = msg;
      errorBox.hidden = false;
      errorBox.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }

    function out(key, text) {
      root.querySelector('[data-widerruf-out="' + key + '"]').textContent = text;
    }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      errorBox.hidden = true;
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      var data = {
        name: form.elements.name.value,
        order_ref: form.elements.order_ref.value,
        email: form.elements.email.value,
        scope: form.elements.scope.value,
        items_note: form.elements.items_note.value,
        hp_fax: form.elements.hp_fax.value,
        confirmed: true,
        source: 'theme'
      };
      submit.disabled = true;
      submit.textContent = 'Wird übermittelt …';

      fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (json) { return { res: res, json: json }; });
        })
        .then(function (r) {
          if (!r.res.ok || !r.json.ok) {
            throw new Error(r.json.error || ('Die Übermittlung ist fehlgeschlagen. ' + FALLBACK));
          }
          if (!r.json.reference) {
            throw new Error('Die Übermittlung ist fehlgeschlagen. ' + FALLBACK);
          }
          out('declaration', '„' + r.json.declaration + '“');
          out('received', r.json.received_date + ' um ' + r.json.received_time);
          out('reference', r.json.reference);
          out('mail', r.json.confirmation_sent
            ? 'Die Eingangsbestätigung haben wir dir an ' + data.email.trim() + ' geschickt. Bitte schau auch im Spam-Ordner nach.'
            : 'Die Bestätigungs-E-Mail konnte gerade nicht automatisch verschickt werden. Dein Widerruf ist trotzdem gespeichert, wir senden dir die Bestätigung umgehend nach. Notiere dir bitte die Vorgangsnummer.');
          formWrap.hidden = true;
          success.hidden = false;
          success.focus();
          success.scrollIntoView({ block: 'start', behavior: 'smooth' });
        })
        .catch(function (err) {
          submit.disabled = false;
          submit.textContent = 'Widerruf bestätigen';
          showError(err && err.message && err.message !== 'Failed to fetch' && err.message !== 'Load failed'
            ? err.message
            : 'Die Verbindung ist fehlgeschlagen. ' + FALLBACK);
        });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
